module.exports = __webpack_public_path__ + "static/media/stroggulo_shma_3d.fbfee568.png";